import _ from 'lodash'

const actions = {
  stage: ({ dispatch, state }, stage) => {
    const stages = _.merge(_.clone(state.projects.entity.stages), stage)

    dispatch('core/projects/update', {
      _id: state.projects.entity._id,
      stages
    })
  }
}

export default actions
